module.exports = __webpack_public_path__ + "static/media/cg.f2e458f5.svg";